import React from 'react'
import { IntegrationsKonnektiveCrmSec } from './integrationsKonnektiveCrmSec'

export const IntegrationsKonnektiveCrm = () => {
  return (
    <IntegrationsKonnektiveCrmSec />
  )
}
